export default "__VITE_ASSET__CIoE0x4d__"